"use client";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks } from "@builder.io/sdk-react";

import { PushBlockContainer as UIPushBlockContainer } from "@jti/ui/components/PushBlockContainer/PushBlockContainer";

import type { pushBlockContainerInputs } from "./PushBlockContainer.builder";

export type PushBlockContainerBuilderProps = BuilderComponentProps<typeof pushBlockContainerInputs> & {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
  attributes: Record<string, string>;
};

export const PushBlockContainer = ({
  carouselDesktop,
  tabletItemCount,
  desktopItemCount,
  isAutoHeight,
  builderBlock,
  builderContext,
  builderComponents,
}: PushBlockContainerBuilderProps) => {
  return (
    <UIPushBlockContainer
      carouselDesktop={carouselDesktop}
      tabletItemCount={tabletItemCount}
      desktopItemCount={desktopItemCount}
      isAutoHeight={isAutoHeight}
    >
      {builderBlock?.children?.map((child) => (
        <Blocks
          key={child.id}
          blocks={[child]}
          parent={builderBlock?.id}
          path="children"
          context={builderContext}
          registeredComponents={builderComponents}
        />
      ))}
    </UIPushBlockContainer>
  );
};
